/* eslint-disable class-methods-use-this */
import React, { useState, useEffect } from 'react';

import 'react-alice-carousel/lib/alice-carousel.css';
import styled from 'styled-components';
import _ from 'lodash';
import NewCourses from './Carousel/NewCourses';
import Courses from './Carousel/Courses';

import LitOnlearning from '../../images/lit.png';
import LitPassLogo from '../../images/litpass-logo.png';
import { gateway } from '../../utils/api';

import imgVocaco from '../../images/logo-vocacao.png';
import { getLoginTenantURL, isTenantValid, extractDomainFromURL } from '../../utils/functions';

const BoxPromo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;

  background-size: ${props => (props.noContain ? 'cover' : 'contain')};
  background-position: center;
`;

const DEFAULT_TENANT = 'LIT_BUSINESS';

function LeftSideBar({ litpass, promo, isVocacao, origin }) {
  const [vitrineData, setVitrineData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [promoLeftBackground, setPromoLeftBackground] = useState({});
  const [loginSettingsState, setLoginSettingsState] = useState({});
  const [isContain, setIsContain] = useState(false);
  const [bgDefaultHeight, setBgDefaultHeight] = useState(0);
  const [renderBackgroundTenant, setRenderBackgroundTenant] = useState(false);
  const [showCoursesTenant, setShowCoursesTenant] = useState(false);

  const getPromoBackground = async isMounted => {
    const params = new URLSearchParams(window.location.search);
    const origin = params.get('o');
    if (origin) {
      await getImageByOrigin(origin, isMounted);
      return;
    }
    if (window.location.pathname === '/') {
      await getVitrineLogin(DEFAULT_TENANT, isMounted);
      return;
    }
    const domain = extractDomainFromURL(window.location.href);
    const isValid = domain ? await isTenantValid(domain) : false;
    const currentLoginTenant = isValid ? domain.toUpperCase() : DEFAULT_TENANT;
    await getVitrineLogin(currentLoginTenant, isMounted);
  };

  const getLoginSettings = async isMounted => {
    const domain = extractDomainFromURL(window.location.href);

    if (!domain) {
      localStorage.setItem('loginTenant', '');
      return;
    }

    if (await isTenantValid(domain)) {
      localStorage.setItem('loginTenant', domain.toUpperCase());
      try {
        const domainSettings = await gateway.get(
          `/webbff/lit_app_web/settings/domainSetting/${domain}`
        );
        if (isMounted) {
          localStorage.setItem(
            'domainSettings',
            JSON.stringify(domainSettings)
          );
          setLoginSettingsState(domainSettings);
        }
      } catch (err) {
        console.log('err', err.message);
      }
    } else {
      localStorage.setItem('loginTenant', '');
    }
  };

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        await getPromoBackground(isMounted);
        if (isMounted) {
          await getLoginSettings(isMounted);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  const getHeight = () =>
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;

  const getWidth = () =>
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  const checkSizeChanged = () => {
    const currentWidth = getWidth();
    const currentHeight = getHeight();
    const sizeContain = currentWidth > 1920;
    setIsContain(sizeContain);
    setBgDefaultHeight(currentHeight);
  };

  useEffect(() => {
    checkSizeChanged();
    // timeoutId for debounce mechanism
    let timeoutId = null;
    const resizeListener = () => {
      // prevent execution of previous setTimeout
      clearTimeout(timeoutId);
      // change width from the state object after 150 milliseconds
      timeoutId = setTimeout(() => {
        checkSizeChanged();
      }, 150);
    };
    // set resize listener
    window.addEventListener('resize', resizeListener);

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener('resize', resizeListener);
    };
  }, []);

  async function getImageByOrigin(origin, isMounted) {
    try {
      const response = await gateway.get(
        `webbff/lit_app_web/content/${origin}`
      );
      if (response && isMounted) {
        setRenderBackgroundTenant(true);
        setPromoLeftBackground({
          backgroundImage: _.get(response, 'url', ''),
          backgroundColor: _.get(response, 'backgroundColor', '')
        });
      } else if (isMounted) {
        setPromoLeftBackground(null);
        setRenderBackgroundTenant(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      if (isMounted) {
        setLoading(false);
      }
    }
  }

  async function getVitrineLogin(tenant, isMounted) {
    try {
      const response = await gateway.get(
        `webbff/lit_app_web/content/getVitrineLogin/${tenant}`
      );

      if (response && isMounted) {
        setVitrineData(response);
        setShowCoursesTenant(true);
      } else if (isMounted) {
        setPromoLeftBackground(null);
        setRenderBackgroundTenant(false);
      }
    } catch (error) {
      if (isMounted) {
        setPromoLeftBackground(null);
        setRenderBackgroundTenant(false);
      }
    } finally {
      if (isMounted) {
        setLoading(false);
      }
    }
  }

  if (loading) {
    return <div style={{ width: '55%', height: 100 }}></div>;
  }

  return (
    <>
      {!origin && !promo && !renderBackgroundTenant && !showCoursesTenant && (
        <div
          className={
            loginSettingsState.primaryBackgroundColor
              ? 'col-md-7 flex-column justify-content-center align-items-center d-none d-md-flex big d-sm-flex'
              : 'col-md-7 flex-column justify-content-center align-items-center d-none d-md-flex bg-loginLeft big d-sm-flex'
          }
          style={
            loginSettingsState.primaryBackgroundColor && {
              backgroundColor: loginSettingsState.primaryBackgroundColor
            }
          }
        >
          {!loginSettingsState.logoUrl && litpass && (
            <img
              src={LitPassLogo}
              width={200}
              // className="align-self-start"
              alt="lit-logo"
            />
          )}
          {!loginSettingsState.logoUrl && isVocacao && (
            <img
              src={LitOnlearning}
              width={200}
              // className="align-self-start"
              alt="lit-logo"
            />
          )}
          {!litpass && !isVocacao && !loginSettingsState.logoUrl && (
            <img
              src={LitOnlearning}
              height={100}
              // className="align-self-start ml-4 my-5"
              alt="lit-logo"
            />
          )}
          {loginSettingsState.logoUrl &&
          loginSettingsState.domain !== 'hinode' ? (
            <img
              src={loginSettingsState.logoUrl}
              height={100}
              // className="align-self-start ml-4 my-5"
              alt="lit-logo"
            />
          ) : null}
        </div>
      )}

      {!origin && !promo && !renderBackgroundTenant && showCoursesTenant && (
        <div className="col-md-7 d-none d-sm-block p-0">
          <Courses data={vitrineData} />
        </div>
      )}

      {(origin ||
        loginSettingsState.domain === 'hinode' ||
        promo ||
        renderBackgroundTenant) &&
        promoLeftBackground &&
        !isVocacao &&
        !litpass && (
          <div
            className="col-md-7 flex-column justify-content-start d-none d-md-flex bg-loginLeft big"
            style={{
              background:
                promoLeftBackground.backgroundColor ||
                loginSettingsState.primaryBackgroundColor ||
                '#FFF',
              padding: 0
            }}
          >
            <BoxPromo
              noContain={isContain}
              style={{
                backgroundImage: `url(${promoLeftBackground.backgroundImage ||
                  loginSettingsState.backgroundImage})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height: bgDefaultHeight,
                maxWidth: '100%'
              }}
            />
          </div>
        )}

      {origin && !promoLeftBackground && (
        <div
          className={
            loginSettingsState.primaryBackgroundColor
              ? 'col-md-7 flex-column justify-content-start d-none d-md-flex big'
              : 'col-md-7 flex-column justify-content-start d-none d-md-flex bg-loginLeft big'
          }
          style={
            loginSettingsState.primaryBackgroundColor && {
              backgroundColor: loginSettingsState.primaryBackgroundColor,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              height: bgDefaultHeight,
              maxWidth: '100%'
            }
          }
        >
          {!loginSettingsState.logoUrl && litpass && (
            <img
              src={LitPassLogo}
              width={200}
              className="align-self-start"
              alt="lit-logo"
            />
          )}
          {!loginSettingsState.logoUrl && isVocacao && (
            <img
              src={LitOnlearning}
              width={200}
              className="align-self-start"
              alt="lit-logo"
            />
          )}
          {!litpass && !isVocacao && !loginSettingsState.logoUrl && (
            <img
              src={LitOnlearning}
              height={100}
              className="align-self-start ml-4 my-5"
              alt="lit-logo"
            />
          )}
          {loginSettingsState.logoUrl &&
          loginSettingsState.domain !== 'hinode' ? (
            <img
              src={loginSettingsState.logoUrl}
              height={100}
              className="align-self-start ml-4 my-5"
              alt="lit-logo"
            />
          ) : null}
          {loginSettingsState.domain !== 'hinode' ? (
            <NewCourses
              title={loginSettingsState.signinCarouselTitle}
              courses={loginSettingsState.signinCarouselItems}
            />
          ) : null}
        </div>
      )}

      {litpass && promo && (
        <div className="col-md-7 flex-column justify-content-start d-none d-md-flex bg-loginLeftPromo big">
          <BoxPromo style={{ backgroundImage: `url(${LitOnlearning})` }} />
        </div>
      )}

      {origin && isVocacao && (
        <div className="col-md-7 flex-column justify-content-start d-none d-md-flex bg-loginLeftPromo big">
          <BoxPromo
            noContain
            style={{ backgroundImage: `url(${imgVocaco})` }}
          />
        </div>
      )}

      {origin && litpass && (
        // on off promo background litpass
        <div className="col-md-7 flex-column justify-content-start d-none d-md-flex bg-loginLeftPromo big">
          <BoxPromo style={{ backgroundImage: `url(${LitOnlearning})` }} />
        </div>
      )}
    </>
  );
}

export default LeftSideBar;
